export default function genererFiltreProduitAssocie() {
  return {
    categorie: [],
    references: [],
    libelles: [],
    tlpe: null,
    honoraire: null,
  };
}
